import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./stores/main";
import { createPinia } from "pinia";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import axios from "axios";
import VueAxios from "vue-axios";
import moment from "moment";
import VMask from "v-mask";
import VueCountryCode from "vue-country-code-select";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.prototype.moment = moment;

Vue.use(VueAxios, axios);
Vue.use(VueCountryCode);
Vue.use(VueToast);
Vue.use(VMask);
Vue.use(createPinia());

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
